export const PREFIX_API = "api";
export enum ApiRoute {
  AUTH = "auth",
  PROFILE = "profile",
  ORG = "org",
  REFERRAL = "referral",
  QUIZ = "quiz",
  CREDIT = "credit",
  BOOKING = "booking",
  TICKET = "ticket",
  EVENT = "event",
  INVITE = "invite",

  MAP = "map",
  USER_RANK = "user-rank",

  PUBLIC = "public",
  PUBLIC_SEO = "public/seo",
  PUBLIC_HEALTH = "public/health",
}

export function getApiRoute(route: ApiRoute, version: string = "v1"): string {
  return `/${PREFIX_API}/${version}/${route}`;
}
